<template>
    <view-card title="담당자 소개" v-if="worker">
        <data-list :dataList="dataList" />
    </view-card>
</template>

<script>
import ViewCard from "./view-card.vue";
import DataList from "./data-list.vue";
export default {
    components: { ViewCard, DataList },
    props: {
        expert: Object,
    },
    computed: {
        worker() {
            const { workerName, workerTitle } = this.expert || {};
            if (workerName && workerTitle) return `${workerName} ${workerTitle}`;
            else return;
        },
        dataList() {
            const list = [];

            if (this.worker) list.push({ term: "담당자", description: this.worker });

            return list;
        },
    },
};
</script>

<style></style>
